export default __webpack_public_path__ + "static/media/sllide3.0a033bda.jpeg";